import * as React from "react";
import { StoreContext } from "../../store/StoreProvider";
import { Typography } from "@material-ui/core";
import { getI18N } from '../../i18n'

interface DashboardBarProps { }

function DashboardHeaderBar() {
    const [store] = React.useContext(StoreContext);

    const { Country } = store?.user;
    const currentLocale: string = Country || "PE";
    const i18n = getI18N({ currentLocale })

    return (
        <>
            <div className="header-title-container-">
                <Typography variant="h6" style={{ textAlign: "start" }}>
                    {i18n.DASHBOARD}
                </Typography>
                <Typography variant="caption">{i18n.DASHBOARD_SUBTITLE}</Typography>
            </div>
        </>
    );
}

export const DashboardBar = React.memo(function DashboardBarComponent(
    props: DashboardBarProps
) {
    return (
        <>
            <DashboardHeaderBar />
        </>
    );
});
